import { render, staticRenderFns } from "./auto-withdraw-scb.vue?vue&type=template&id=5f27ca72&scoped=true&"
import script from "./auto-withdraw-scb.vue?vue&type=script&lang=js&"
export * from "./auto-withdraw-scb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27ca72",
  null
  
)

export default component.exports